export default __webpack_public_path__ + "static/media/woman.298047e5.svg";